import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {ToggleFullscreenDirective} from './fullscreen/toggle-fullscreen.directive';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ScrollModule} from './scroll/scroll.module';
import {MenuItems} from './menu-items/menu-items';
import {SpinnerComponent} from './spinner/spinner.component';
import {CardComponent} from './card/card.component';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';
import {DataFilterPipe} from './element/data-filter.pipe';
import { SearchPipe } from './filters/search.pipe';
import { ShowErrorsComponent } from './element/show-errors.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { GuiaTelefonicaComponent } from './element/guia-telefonica.component';
import { ListaContactosComponent } from './element/lista-contactos.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ModalMensajeUsuarioComponent } from './modal/modal-mensaje-usuario/modal-mensaje-usuario.component';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ModalModificarContraseniaComponent } from './modal/modal-modificar-contrasenia/modal-modificar-contrasenia.component';
import { ModalMensajeConfirmacionComponent } from './modal/modal-mensaje-confirmacion/modal-mensaje-confirmacion.component';
import { ModalFinalizarMatriculaComponent } from './modal/modal-finalizar-matricula/modal-finalizar-matricula.component';
import { ModalModificarImagenComponent } from './modal/modal-modificar-imagen/modal-modificar-imagen.component';
import { NgUppercaseLowercaseDirective } from './element/ng-uppercase-lowercase.directive';
import { UppercaseDirective } from './element/uppercase.directive';
import { EstadoMayorPipe } from './filters/estado-mayor.pipe';
import { SearchEstadoMatriculaPipe } from './filters/search-estado-matricula.pipe';
import { SearchCampoValorPipe } from './filters/search-campo-valor.pipe';
import { FrmLowercaseDirective } from './element/frm-lowercase.directive';
import { UbicacionEcuadorComponent } from './element/formularios/ubicacion-ecuador.component';
import { DatosComplementariosBasicosComponent } from './element/formularios/datos-complementarios-basicos.component';
import { FormAsignaturaComponent } from './element/formularios/form-asignatura.component';
import { FormAsignarPensumComponent } from './element/formularios/form-asignar-pensum.component';
import { SelectCursoEspecialidadParaleloComponent } from './element/select-curso-especialidad-paralelo.component';
import { FormulaPorListasComponent } from './element/formula-por-listas.component';
import { FormAsignaturaAreaComponent } from './element/formularios/form-asignatura-area.component';
import{ModalFormAsignaturaAreaComponent } from './modal/modal-form-asignatura-area/modal-form-asignatura-area.component';
import { EstadoFechaIngresoSalidaComponent } from './element/formularios/estado-fecha-ingreso-salida.component';
import { ModalAsignarActividadesComponent } from './modal/modal-asignar-actividades/modal-asignar-actividades.component';
import { ObtenerOrdenActividadesCheckComponent } from './element/obtener-orden-actividades-check.component'
import {SelectModule} from 'ng-select';
import { FormPorcentajeBecaComponent } from './element/formularios/form-porcentaje-beca.component';
import { SelectorEmpresaSucursalRolComponent } from './element/selector-empresa-sucursal-rol.component';
import { BuscarAsignaturasPensumComponent } from './element/buscar-asignaturas-pensum.component';
import {NgPipesModule} from 'ngx-pipes';
import { SelectorCicloCalificacionesComponent } from './element/selector-ciclo-calificaciones.component';
import { CuadroColorAvisoComponent } from './element/cuadro-color-aviso.component';
import { TablaIngresoTareasComponent } from './element/tabla-ingreso-tareas.component';
import {NgDecimalesDirective} from './directive/ng-decimales.directive'
import{TipoDecimalPipe} from './pipes/tipo-decimal.pipe';
import { ModalCambiarNotaComponent } from './modal/modal-cambiar-nota/modal-cambiar-nota.component';
import { NotasAlumnosPipe } from './filters/notas-alumnos.pipe';
import { ModalCausasCalificacionComponent } from './modal/modal-causas-calificacion/modal-causas-calificacion.component';
import { TablaCalificacionMateriaComponent } from './element/tabla-calificacion-materia.component';
import { ModalCopiarNotaComponent } from './modal/modal-copiar-nota/modal-copiar-nota.component';
import { TablaCalificacionComportamientoComponent } from './element/tabla-calificacion-comportamiento.component';
import { TreeBasicoComponent } from './element/tree-basico.component';
import { TablaHorariosAcademicosComponent } from './element/tabla-horarios-academicos.component'

import {DndModule} from 'ng2-dnd';
import { TablaAsistenciaEstudiantesComponent } from './element/tabla-asistencia-estudiantes.component';
import{I18n, CustomDatepickerI18n} from './services/api-rest.service'
import {NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import { TreePermisoActividadComponent } from './element/tree-permiso-actividad.component';
import { BuscarEntreFechasPipe } from './filters/buscar-entre-fechas.pipe';
import { SelectorGruposComponent } from './element/selector-grupos.component';
import { AdjuntarArchivosComponent } from './element/adjuntar-archivos.component';
import { TreeArchivosComponent } from './element/tree-archivos.component';
import { BuscarUsuariosGrupoComponent } from './element/buscar-usuarios-grupo.component';
import { FormEnvioMailComponent } from './element/form-envio-mail.component';
import { NgxEditorModule } from 'ngx-editor';
import { ViewMailComponent } from './element/view-mail.component';
import { RangoPipe } from './pipes/rango.pipe';
import { DatosCursoComponent }  from './fichaEstudiante/datos-curso.component';
import { DatosPrincipalesComponent } from './fichaEstudiante/datos-principales.component';
import { DatosMatriculaComponent } from './fichaEstudiante/datos-matricula.component';
import { DatosAutorizaComponent } from './fichaEstudiante/datos-autoriza.component';
import { DatosComplementariosComponent } from './fichaEstudiante/datos-complementarios.component';
import { DatosUbicacionComponent } from './fichaEstudiante/datos-ubicacion.component';
import { DatosHermanosComponent } from './fichaEstudiante/datos-hermanos.component';
import { DatosEmergenciaComponent } from './fichaEstudiante/datos-emergencia.component';
import { DatosPadresComponent } from './fichaEstudiante/datos-padres.component';
import { DatosFacturaComponent } from './fichaEstudiante/datos-factura.component';
import { ValidarIdentificacionDirective } from './directive/validar-identificacion.directive';
import { ValidarContraseniaDirective } from './directive/validar-contrasenia.directive';
import { CotarTextosPipe } from './pipes/cotar-textos.pipe';
import { AceptarAcuerdoMatriculaComponent } from './fichaEstudiante/aceptar-acuerdo-matricula.component';
import { DatosSalidaComponent } from './fichaEstudiante/datos-salida.component';
import { TreeDocumentosEntregarComponent } from './element/tree-documentos-entregar.component';
import {AdjuntarArchivosMensajeComponent} from './element/adjuntar-archivo-mensaje.component'
import {MatriculaDocumentoComponent} from './element/matricula-documento/matricula-documento.component'


//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { ToastrModule } from 'ngx-toastr';


@NgModule({
  imports: [
    CommonModule,
    ScrollModule,
    NgbModule.forRoot(),
    DndModule.forRoot(),
    ImageCropperModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    NgPipesModule,
    NgxEditorModule ,
    //BrowserAnimationsModule,
    //ToastrModule.forRoot()

  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    SpinnerComponent,
    CardComponent,
    DataFilterPipe,
    SearchPipe,
    EstadoMayorPipe,
    ShowErrorsComponent,
    GuiaTelefonicaComponent,
    ListaContactosComponent,
    ModalMensajeUsuarioComponent,
    ModalModificarContraseniaComponent,
    ModalMensajeConfirmacionComponent,
    ModalFinalizarMatriculaComponent,
    ModalModificarImagenComponent,
    NgUppercaseLowercaseDirective,
    UppercaseDirective,
    EstadoMayorPipe,
    SearchEstadoMatriculaPipe,
    SearchCampoValorPipe,
    FrmLowercaseDirective,
    UbicacionEcuadorComponent,
    DatosComplementariosBasicosComponent,
    FormAsignaturaComponent,
    FormAsignarPensumComponent,
    SelectCursoEspecialidadParaleloComponent,
    FormulaPorListasComponent,
    FormAsignaturaAreaComponent,
    ModalFormAsignaturaAreaComponent,
    EstadoFechaIngresoSalidaComponent,
    ModalAsignarActividadesComponent,
    ObtenerOrdenActividadesCheckComponent,
    FormPorcentajeBecaComponent,
    SelectorEmpresaSucursalRolComponent,
    BuscarAsignaturasPensumComponent,
    SelectorCicloCalificacionesComponent,
    CuadroColorAvisoComponent,
    TablaIngresoTareasComponent,
    NgDecimalesDirective,
    TipoDecimalPipe,
    ModalCambiarNotaComponent,
    NotasAlumnosPipe,
    ModalCausasCalificacionComponent,
    TablaCalificacionMateriaComponent,
    ModalCopiarNotaComponent,
    TablaCalificacionComportamientoComponent,
    TreeBasicoComponent,
    TablaHorariosAcademicosComponent,
    TablaAsistenciaEstudiantesComponent,
    TreePermisoActividadComponent,
    BuscarEntreFechasPipe,
    SelectorGruposComponent,
    AdjuntarArchivosComponent,
    TreeArchivosComponent,
    BuscarUsuariosGrupoComponent,
    FormEnvioMailComponent,
    ViewMailComponent,
    RangoPipe,
    DatosCursoComponent,
    DatosPrincipalesComponent,
    DatosMatriculaComponent,
    DatosAutorizaComponent,
    DatosComplementariosComponent,
    DatosUbicacionComponent,
    DatosHermanosComponent,
    DatosEmergenciaComponent,
    DatosPadresComponent,
    DatosFacturaComponent,
    ValidarIdentificacionDirective,
    ValidarContraseniaDirective,
    CotarTextosPipe,
    AceptarAcuerdoMatriculaComponent,
    DatosSalidaComponent,
    TreeDocumentosEntregarComponent,
    AdjuntarArchivosMensajeComponent,
    MatriculaDocumentoComponent
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ScrollModule,
    NgbModule,
    SpinnerComponent,
    CardComponent,
    DataFilterPipe,
    SearchPipe,
    EstadoMayorPipe,
    ShowErrorsComponent,
    ImageCropperModule,
    ListaContactosComponent,
    NgUppercaseLowercaseDirective,
    SearchEstadoMatriculaPipe,
    UppercaseDirective,
    SearchCampoValorPipe,
    FrmLowercaseDirective,
    UbicacionEcuadorComponent,
    DatosComplementariosBasicosComponent,
    FormAsignaturaComponent,
    FormAsignarPensumComponent,
    SelectCursoEspecialidadParaleloComponent,
    FormulaPorListasComponent,
    FormAsignaturaAreaComponent,
    EstadoFechaIngresoSalidaComponent,
    ObtenerOrdenActividadesCheckComponent,
    SelectModule,
    FormPorcentajeBecaComponent,
    SelectorEmpresaSucursalRolComponent,
    BuscarAsignaturasPensumComponent,
    SelectorCicloCalificacionesComponent,
    CuadroColorAvisoComponent,
    TablaIngresoTareasComponent,
    NgDecimalesDirective,
    TablaCalificacionMateriaComponent,
    TablaCalificacionComportamientoComponent,
    TreeBasicoComponent,
    TablaHorariosAcademicosComponent,
    DndModule,
    TablaAsistenciaEstudiantesComponent,
    TreePermisoActividadComponent,
    BuscarEntreFechasPipe,
    SelectorGruposComponent,
    AdjuntarArchivosComponent,
    TreeArchivosComponent,
    BuscarUsuariosGrupoComponent,
    FormEnvioMailComponent,
    ViewMailComponent,
    RangoPipe,
    DatosCursoComponent,
    DatosPrincipalesComponent,
    DatosMatriculaComponent,
    DatosAutorizaComponent,
    DatosComplementariosComponent,
    DatosUbicacionComponent,
    DatosHermanosComponent,
    DatosEmergenciaComponent,
    DatosPadresComponent,
    DatosFacturaComponent,
    ValidarIdentificacionDirective,
    ModalModificarContraseniaComponent,
    ValidarContraseniaDirective,
    CotarTextosPipe,
    AceptarAcuerdoMatriculaComponent,
    DatosSalidaComponent,
    TreeDocumentosEntregarComponent,
    AdjuntarArchivosMensajeComponent,
    MatriculaDocumentoComponent
  ],
  providers: [
    MenuItems,
    NgbActiveModal,
    I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}
  ],
  entryComponents: [
    ModalMensajeUsuarioComponent,
    ModalModificarContraseniaComponent,
    ModalMensajeConfirmacionComponent, 
    ModalModificarImagenComponent,
    ModalFormAsignaturaAreaComponent,
    ModalAsignarActividadesComponent,
    ModalCausasCalificacionComponent,
    ModalCopiarNotaComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts